<template>
	<div class="template textarea">
		<div class="panel_wrap">
			<div class="file-wrap-title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</div>
			<div class="panel_content">
				<el-input type="textarea" :rows="4" :autosize="{ minRows: 2, maxRows: 6}" :readOnly="dataVal.Disable||dataVal.Property.Title[0].Text=='晋升说明'||dataVal.Property.Title[0].Text=='端口费用承担部门'" :placeholder="dataVal.Placeholder" v-model="dataVal.Value">
				</el-input>

				<!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="dataVal.Value">
				</el-input> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		methods: {

		},
		mounted() {
		}
	}
</script>

<style scoped>
	@import '../../assets/css/common.css';

	.panel_wrap {
		display: block;
	}
</style>
